module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAICAYAAADA+m62AAAAdklEQVQoU2NkUiwuZmRkrGD6x+Dz+0HPSXQ+AxQwgmhmxeJYBkbGSQyM/6P+3u3djs4HqQErBCtWLvZk+M+4jOH//7y/93sXo/PhCkGKWRVKzP8xMWz5//9/x7/7vb3IfBwKGTv/3e/uQShk7CTNaqI8Q2zwAADMMmwe3IgU0QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/image/more.png
// module id = /V6A
// module chunks = 29